import { StyleSheet } from 'aphrodite';
import { brandPrimary } from '../../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	title: {
		fontSize: '20px',
		fontWeight: 600,
		color: '#000000',
		margin: 0,
	},
	content: {
		padding: '0 24px',
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
	},
	textarea: {
		flex: 1,
		minHeight: '200px',
		padding: '12px',
		backgroundColor: '#FFFFFF',
		color: '#000000',
		border: `1px solid #CCCCCC`,
		borderRadius: '8px',
		fontSize: '14px',
		fontFamily: 'inherit',
		resize: 'vertical',
		':focus': {
			outline: 'none',
			borderColor: brandPrimary,
		},
		'::placeholder': {
			color: '#999999',
		},
	},
	characterCount: {
		fontSize: '12px',
		color: '#777777',
		textAlign: 'right',
		marginTop: '8px',
	},
	footer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
	},
	footerActions: {
		display: 'flex',
		gap: '12px',
	},
});
